import { useState, useEffect, useContext, useCallback } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useReadMyMeetings = () => {
  const [meetings, setMeetings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const { token } = useContext(AuthContext);

  const fetchMeetings = useCallback(async () => {
    if (!token) return;
    
    setIsLoading(true);
    setIsError(false);
    setError(null);

    try {
      const baseUrl = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';
      const apiUrl = `${baseUrl}/meeting/vesselOwner/me`;
      
      console.log('Fetching vessel owner meetings from:', apiUrl);
      console.log('Token available:', !!token);
      
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      console.log('Response status:', response.status);
      console.log('Response ok:', response.ok);

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch meetings");
      }

      const data = await response.json();
      console.log('Raw API response:', data);
      
      // Handle new API response structure: { status, results, data: [...] }
      const meetingsData = data.data || data || [];
      console.log('Setting meetings to:', meetingsData);
      
      setMeetings(meetingsData);
    } catch (err) {
      setIsError(true);
      setError(err);
      console.error("Error fetching vessel owner meetings:", err);
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchMeetings();
  }, [token, fetchMeetings]);

  return {
    meetings,
    isLoading,
    isError,
    error,
    refetch: fetchMeetings,
  };
};

export default useReadMyMeetings; 